import { Action } from 'redux';
import { OrderedMap } from 'immutable';
import { Moment } from 'moment';

import {
    GET_CUSTOM_FLOWERS_CITIES_REQUEST,
    GET_CUSTOM_FLOWERS_CITIES_RESPONSE,
    GET_CUSTOM_FLOWERS_CITIES_ERROR,

    GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_REQUEST,
    GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_RESPONSE,
    GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_ERROR,

    GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_REQUEST,
    GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_RESPONSE,
    GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_ERROR,

    GET_CUSTOM_FLOWERS_BOUQUET_REQUEST,
    GET_CUSTOM_FLOWERS_BOUQUET_RESPONSE,
    GET_CUSTOM_FLOWERS_BOUQUET_ERROR,

    ORDER_CUSTOM_FLOWERS_BOUQUET_REQUEST,
    ORDER_CUSTOM_FLOWERS_BOUQUET_RESPONSE,
    ORDER_CUSTOM_FLOWERS_BOUQUET_ERROR,

    RESET_ORDER_CUSTOM_FLOWERS,

    GET_FLOWWOW_FLOWERS_CITIES_REQUEST,
    GET_FLOWWOW_FLOWERS_CITIES_RESPONSE,
    GET_FLOWWOW_FLOWERS_CITIES_ERROR,

    GET_FLOWWOW_FLOWERS_COMPILATION_REQUEST,
    GET_FLOWWOW_FLOWERS_COMPILATION_RESPONSE,
    GET_FLOWWOW_FLOWERS_COMPILATION_ERROR,

    GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST,
    GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE,
    GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR,

    GET_FLOWWOW_FLOWERS_BOUQUET_REQUEST,
    GET_FLOWWOW_FLOWERS_BOUQUET_RESPONSE,
    GET_FLOWWOW_FLOWERS_BOUQUET_ERROR,

    ORDER_FLOWWOW_FLOWERS_BOUQUET_REQUEST,
    ORDER_FLOWWOW_FLOWERS_BOUQUET_RESPONSE,
    ORDER_FLOWWOW_FLOWERS_BOUQUET_ERROR,

    SET_CUSTOM_FLOWERS_CITY,
    SET_FLOWWOW_CITY,

    SET_CUSTOM_FLOWERS_COMPILATION,
    SET_FLOWWOW_COMPILATION,

    SET_CITY_INPUT,

    SET_CUSTOM_FLOWERS_BOUQUET,
    SET_FLOWWOW_BOUQUET,

    SET_CUSTOM_COMMENT,
    SET_CUSTOM_DATE_TIME,
    SET_CUSTOM_SENDER_CARD,
    SET_CUSTOM_SENDER_NAME,
    SET_CUSTOM_SENDER_PHONE,
    SET_CUSTOM_RECIPIENT_NAME,
    SET_CUSTOM_RECIPIENT_PHONE,
    SET_CUSTOM_RECIPIENT_ADDRESS,

    SET_FLOWWOW_DELIVERY_FROM,
    SET_FLOWWOW_DELIVERY_TO,
    SET_FLOWWOW_DELIVERY_TYPE,
    SET_FLOWWOW_SENDER_NAME,
    SET_FLOWWOW_SENDER_PHONE,
    SET_FLOWWOW_SENDER_CARD,
    SET_FLOWWOW_RECIPIENT_NAME,
    SET_FLOWWOW_RECIPIENT_PHONE,
    SET_FLOWWOW_RECIPIENT_ADDRESS,

    GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST,
    GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE,
    GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR
} from '../../actions/CustomFlowers/customFlowers';

import { CustomCity, FlowwowCity } from '../../models/CustomFlowers/City';
import { CustomCompilation, FlowwowCompilation } from '../../models/CustomFlowers/Compilation';
import { CustomBouquet, FlowwowBouquet } from '../../models/CustomFlowers/Bouquet';

export interface CustomFlowersState {
    customCities: OrderedMap<number, CustomCity>;
    loadingCustomCities: boolean;
    errorCustomCities: any;

    customCompilations: OrderedMap<number, CustomCompilation>;
    loadingCustomCompilations: boolean;
    errorCustomCompilations: any;

    customCompilationBouquets: OrderedMap<number, CustomBouquet>;
    loadingCustomCompilationBouquets: boolean;
    errorCustomCompilationBouquets: any;

    customOrder: boolean;
    loadingCustomOrder: boolean;
    errorCustomOrder: any;

    flowwowCities: OrderedMap<string, FlowwowCity>;
    loadingFlowwowCities: boolean;
    errorFlowwowCities: any;

    flowwowCompilations: OrderedMap<number, FlowwowCompilation>;
    loadingFlowwowCompilations: boolean;
    errorFlowwowCompilations: any;

    flowwowCompilationBouquets: OrderedMap<string, FlowwowBouquet>;
    loadingFlowwowCompilationBouquets: boolean;
    errorFlowwowCompilationBouquets: any;

    flowwowPayLink: string;
    loadingFlowwowPayLink: boolean;
    errorFlowwowPayLink: any;

    customCity: CustomCity;
    flowwowCity: FlowwowCity;

    customCompilation: CustomCompilation;
    flowwowCompilation: FlowwowCompilation;

    cityInput: string;

    customBouquet: CustomBouquet;
    flowwowBouquet: FlowwowBouquet;

    customComment: string;
    customSenderName: string;
    customSenderPhone: string;
    customSenderCard: string;
    customDateTime: Moment | null;
    customRecipientName: string;
    customRecipientPhone: string;
    customRecipientAddress: string;

    isBouquetUpdate: boolean;
    isCityUpdate: boolean;
    isDeliveryDateUpdate: boolean;
    isSenderNameUpdate: boolean;
    isSenderCardUpdate: boolean;
    isRecipientPhoneUpdate: boolean;
    isSenderPhoneUpdate: boolean;
    isRecipientNameUpdate: boolean;
    isRecipientAddressUpdate: boolean;
    isCommentUpdate: boolean;
    isMakeOrder: boolean;

    flowwowDeliveryFrom: Moment | null;
    flowwowDeliveryTo: Moment | null;
    flowwowDeliveryType: 1 | 2;
    flowwowSenderName: string;
    flowwowSenderPhone: string;
    flowwowSenderCard: string;
    flowwowRecipientName: string;
    flowwowRecipientPhone: string;
    flowwowRecipientAddress: string;
    isFBouquetUpdate: boolean;
    isFCityUpdate: boolean;
    isFRecipientAddressUpdate: boolean;
    isFSenderCardUpdate: boolean;
    isFSenderPhoneUpdate: boolean;
    isFRecipientPhoneUpdate: boolean;
    isFSenderNameUpdate: boolean;
    isFRecipientNameUpdate: boolean;
    isFDeliveryFromUpdate: boolean;
    isFDeliveryToUpdate: boolean;
    isFDeliveryTypeUpdate: boolean;
    isFMakeOrder: boolean;
    flowwowBouquetsPage: number;
    isEndPagination: boolean;
}

const initialState: CustomFlowersState = {
    customCities: OrderedMap<number, CustomCity>(),
    loadingCustomCities: false,
    errorCustomCities: null,

    customCompilations: OrderedMap<number, CustomCompilation>(),
    loadingCustomCompilations: false,
    errorCustomCompilations: null,

    customCompilationBouquets: OrderedMap<number, CustomBouquet>(),
    loadingCustomCompilationBouquets: false,
    errorCustomCompilationBouquets: null,

    customOrder: false,
    loadingCustomOrder: false,
    errorCustomOrder: null,

    flowwowCities: OrderedMap<string, FlowwowCity>(),
    loadingFlowwowCities: false,
    errorFlowwowCities: null,

    flowwowCompilations: OrderedMap<number, FlowwowCompilation>(),
    loadingFlowwowCompilations: false,
    errorFlowwowCompilations: null,

    flowwowCompilationBouquets: OrderedMap<string, FlowwowBouquet>(),
    loadingFlowwowCompilationBouquets: false,
    errorFlowwowCompilationBouquets: null,

    flowwowPayLink: '',
    loadingFlowwowPayLink: false,
    errorFlowwowPayLink: null,

    flowwowCity: {} as FlowwowCity,
    customCity: {} as CustomCity,

    flowwowCompilation: {} as FlowwowCompilation,
    customCompilation: {} as CustomCompilation,
    
    cityInput: '',

    customBouquet: {} as CustomBouquet,
    flowwowBouquet: {} as FlowwowBouquet,
    
    customComment: '',
    customSenderCard: '',
    customSenderName: '',
    customSenderPhone: '',
    customDateTime: null,
    customRecipientPhone: '',
    customRecipientName: '',
    customRecipientAddress: '',

    isBouquetUpdate: false,
    isCityUpdate: false,
    isDeliveryDateUpdate: false,
    isSenderNameUpdate: false,
    isSenderCardUpdate: false,
    isRecipientPhoneUpdate: false,
    isSenderPhoneUpdate: false,
    isRecipientNameUpdate: false,
    isRecipientAddressUpdate: false,
    isCommentUpdate: false,
    isMakeOrder: false,

    flowwowDeliveryFrom: null,
    flowwowDeliveryTo: null,
    flowwowDeliveryType: 1,
    flowwowSenderName: '',
    flowwowSenderPhone: '',
    flowwowSenderCard: '',
    flowwowRecipientName: '',
    flowwowRecipientPhone: '',
    flowwowRecipientAddress: '',
    isFBouquetUpdate: false,
    isFCityUpdate: false,
    isFRecipientAddressUpdate: false,
    isFSenderCardUpdate: false,
    isFSenderPhoneUpdate: false,
    isFRecipientPhoneUpdate: false,
    isFSenderNameUpdate: false,
    isFRecipientNameUpdate: false,
    isFDeliveryFromUpdate: false,
    isFDeliveryToUpdate: false,
    isFDeliveryTypeUpdate: false,
    isFMakeOrder: false,
    flowwowBouquetsPage: 1,
    isEndPagination: false
};

export function customFlowers(state: CustomFlowersState = initialState, action: Action) {
    switch (action.type) {
        case GET_CUSTOM_FLOWERS_CITIES_REQUEST: {
            return {
                ...state,
                loadingCustomCities: true,
                errorCustomCities: null
            };
        }
        case GET_CUSTOM_FLOWERS_CITIES_RESPONSE: {
            const result = (action as any).response.result;
            const customCities = (result as Array<CustomCity>).reduce((prev, cur) => prev.set(cur.id, cur), initialState.customCities);
            return {
                ...state,
                loadingCustomCities: false,
                customCities
            };
        }
        case GET_CUSTOM_FLOWERS_CITIES_ERROR: {
            const errorCustomCities = (action as any).error;
            return {
                ...state,
                loadingCustomCities: false,
                errorCustomCities
            };
        }
        case GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_REQUEST: {
            return {
                ...state,
                loadingCustomCompilations: true,
                errorCustomCompilations: null
            };
        }

        case GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_RESPONSE: {
            const result = (action as any).response.result;
            const customCompilations = (result as Array<CustomCompilation>).reduce((prev, cur) => prev.set(cur.id, cur), initialState.customCompilations);
            return {
                ...state,
                loadingCustomCompilations: false,
                customCompilations
            };
        }
        case GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_ERROR: {
            const errorCustomCompilations = (action as any).error;
            return {
                ...state,
                loadingCustomCompilations: false,
                errorCustomCompilations
            };
        }
        case GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_REQUEST: {
            return {
                ...state,
                loadingCustomCompilationBouquets: false,
                errorCustomCompilationBouquets: initialState.errorCustomCompilationBouquets,
                customCompilationBouquets: initialState.customCompilationBouquets
            };
        }
        case GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_RESPONSE: {
            const result = (action as any).response.result;
            const customCompilationBouquets = (result as Array<CustomBouquet>).reduce((prev, cur) => prev.set(cur.id, cur), initialState.customCompilationBouquets);
            return {
                ...state,
                loadingCustomCompilationBouquets: false,
                customCompilationBouquets
            };
        }
        case GET_CUSTOM_FLOWERS_BOUQUET_COMPILATION_BOUQUETS_ERROR: {
            const errorCustomCompilationBouquets = (action as any).error;
            return {
                ...state,
                loadingCustomCompilationBouquets: false,
                errorCustomCompilationBouquets
            };
        }
        case GET_CUSTOM_FLOWERS_BOUQUET_REQUEST: {
            return {
                ...state
            };
        }
        case GET_CUSTOM_FLOWERS_BOUQUET_RESPONSE: {
            return {
                ...state,
                customBouquet: (action as any).response.result,
                isBouquetUpdate: true
            };
        }
        case GET_CUSTOM_FLOWERS_BOUQUET_ERROR: {
            return {
                ...state
            };
        }
        case ORDER_CUSTOM_FLOWERS_BOUQUET_REQUEST: {
            return {
                ...state,
                customOrder: false,
                loadingCustomOrder: true,
                errorCustomOrder: initialState.errorCustomOrder,
                isMakeOrder: true
            };
        }
        case ORDER_CUSTOM_FLOWERS_BOUQUET_RESPONSE: {
            return {
                ...state,
                customOrder: true,
                loadingCustomOrder: false
            };
        }
        case ORDER_CUSTOM_FLOWERS_BOUQUET_ERROR: {
            const errorCustomOrder = (action as any).error;
            return {
                ...state,
                customOrder: false,
                loadingCustomOrder: false,
                errorCustomOrder
            };
        }
        case RESET_ORDER_CUSTOM_FLOWERS: {
            return {
                ...state,
                customOrder: false,
                loadingCustomOrder: false,
                errorCustomOrder: initialState.errorCustomOrder,
                isMakeOrder: false
            };
        }
        case GET_FLOWWOW_FLOWERS_CITIES_REQUEST: {
            return {
                ...state,
                loadingFlowwowCities: true,
                errorFlowwowCities: null
            };
        }
        case GET_FLOWWOW_FLOWERS_CITIES_RESPONSE: {
            const result = (action as any).response.result;
            const flowwowCities = (result as Array<FlowwowCity>).reduce((prev, cur) => prev.set(cur.id, cur), initialState.flowwowCities);
            return {
                ...state,
                loadingFlowwowCities: false,
                flowwowCities
            };
        }
        case GET_FLOWWOW_FLOWERS_CITIES_ERROR: {
            const errorFlowwowCities = (action as any).error;
            return {
                ...state,
                loadingFlowwowCities: false,
                errorFlowwowCities
            };
        }
        case GET_FLOWWOW_FLOWERS_COMPILATION_REQUEST: {
            return {
                ...state,
                loadingFlowwowCompilations: true,
                errorFlowwowCompilations: null
            };
        }

        case GET_FLOWWOW_FLOWERS_COMPILATION_RESPONSE: {
            const result = (action as any).response.result;
            const flowwowCompilations = (result as Array<FlowwowCompilation>).reduce((prev, cur) => prev.set(cur.id, cur), initialState.flowwowCompilations);
            return {
                ...state,
                loadingFlowwowCompilations: false,
                flowwowCompilations
            };
        }
        case GET_FLOWWOW_FLOWERS_COMPILATION_ERROR: {
            const errorFlowwowCompilations = (action as any).error;
            return {
                ...state,
                loadingFlowwowCompilations: false,
                errorFlowwowCompilations
            };
        }
        case GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST: {
            return {
                ...state,
                loadingFlowwowCompilationBouquets: true,
                errorFlowwowCompilationBouquets: initialState.errorFlowwowCompilationBouquets,
                flowwowCompilationBouquets: initialState.flowwowCompilationBouquets
            };
        }
        case GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE: {
            const result = (action as any).response.result;
            const flowwowCompilationBouquets = (result as Array<FlowwowBouquet>).reduce((prev, cur) => prev.set(cur.id, cur), initialState.flowwowCompilationBouquets);
            return {
                ...state,
                loadingFlowwowCompilationBouquets: false,
                flowwowCompilationBouquets
            };
        }
        case GET_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR: {
            const errorFlowwowCompilationBouquets = (action as any).error;
            return {
                ...state,
                loadingFlowwowCompilationBouquets: false,
                errorFlowwowCompilationBouquets
            };
        }
        case GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_REQUEST: {
            return {
                ...state,
                loadingFlowwowCompilations: true,
                errorFlowwowCompilationBouquets: initialState.errorFlowwowCompilationBouquets
            };
        }
        case GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_RESPONSE: {
            const result = (action as any).response.result;
            const flowwowBouquetsPage = (action as any).page;
            const isEndPagination = (action as any).response.result.length === 0;
            const flowwowCompilationBouquets = (result as Array<FlowwowBouquet>).reduce((prev, cur) => prev.set(cur.id, cur), state.flowwowCompilationBouquets);
            return {
                ...state,
                loadingFlowwowCompilations: false,
                flowwowCompilationBouquets,
                flowwowBouquetsPage,
                isEndPagination
            };
        }
        case GET_MORE_FLOWWOW_FLOWERS_COMPILATION_BOUQUETS_ERROR: {
            const errorFlowwowCompilationBouquets = (action as any).error;
            return {
                ...state,
                loadingFlowwowCompilations: false,
                errorFlowwowCompilationBouquets
            };
        }
        case GET_FLOWWOW_FLOWERS_BOUQUET_REQUEST: {
            return {
                ...state
            };
        }
        case GET_FLOWWOW_FLOWERS_BOUQUET_RESPONSE: {
            return {
                ...state
            };
        }
        case GET_FLOWWOW_FLOWERS_BOUQUET_ERROR: {
            return {
                ...state
            };
        }
        case ORDER_FLOWWOW_FLOWERS_BOUQUET_REQUEST: {
            return {
                ...state,
                loadingFlowwowPayLink: true,
                errorFlowwowPayLink: initialState.errorFlowwowPayLink,
                isFMakeOrder: true
            };
        }
        case ORDER_FLOWWOW_FLOWERS_BOUQUET_RESPONSE: {
            const result = (action as any).response.result;
            const flowwowPayLink = result.pay_link;
            return {
                ...state,
                flowwowPayLink,
                loadingFlowwowPayLink: false
            };
        }
        case ORDER_FLOWWOW_FLOWERS_BOUQUET_ERROR: {
            const errorFlowwowOrder = (action as any).error;
            return {
                ...state,
                loadingFlowwowPayLink: false,
                errorFlowwowOrder
            };
        }

        case SET_CUSTOM_FLOWERS_CITY: {
            return {
                ...state,
                customCity: (action as any).city,
                isCityUpdate: true
            };
        }
        case SET_FLOWWOW_CITY: {
            return {
                ...state,
                flowwowCity: (action as any).city,
                isFCityUpdate: true
            };
        }
        case SET_CUSTOM_FLOWERS_COMPILATION: {
            return {
                ...state,
                customCompilation: (action as any).compilation
            };
        }
        case SET_FLOWWOW_COMPILATION: {
            return {
                ...state,
                flowwowCompilation: (action as any).compilation
            };
        }
        case SET_CITY_INPUT: {
            return {
                ...state,
                cityInput: (action as any).city
            };
        }
        case SET_CUSTOM_FLOWERS_BOUQUET: {
            return {
                ...state,
                customBouquet: (action as any).bouquet,
                isBouquetUpdate: true
            };
        }
        case SET_FLOWWOW_BOUQUET: {
            return {
                ...state,
                flowwowBouquet: (action as any).bouquet,
                isFBouquetUpdate: true
            };
        }
        case SET_CUSTOM_COMMENT: {
            return {
                ...state,
                customComment: (action as any).comment,
                isCommentUpdate: true
            };
        }
        case SET_CUSTOM_DATE_TIME: {
            return {
                ...state,
                customDateTime: (action as any).dateTime,
                isDeliveryDateUpdate: true
            };
        }
        case SET_CUSTOM_SENDER_CARD: {
            return {
                ...state,
                customSenderCard: (action as any).card,
                isSenderCardUpdate: true
            };
        }
        case SET_CUSTOM_SENDER_NAME: {
            return {
                ...state,
                customSenderName: (action as any).name,
                isSenderNameUpdate: true
            };
        }
        case SET_CUSTOM_SENDER_PHONE: {
            return {
                ...state,
                customSenderPhone: (action as any).phone,
                isSenderPhoneUpdate: true
            };
        }
        case SET_CUSTOM_RECIPIENT_ADDRESS: {
            return {
                ...state,
                customRecipientAddress: (action as any).address,
                isRecipientAddressUpdate: true
            };
        }
        case SET_CUSTOM_RECIPIENT_NAME: {
            return {
                ...state,
                customRecipientName: (action as any).name,
                isRecipientNameUpdate: true
            };
        }
        case SET_CUSTOM_RECIPIENT_PHONE: {
            return {
                ...state,
                customRecipientPhone: (action as any).phone,
                isRecipientPhoneUpdate: true
            };
        }
        case SET_FLOWWOW_DELIVERY_FROM: {
            return {
                ...state,
                flowwowDeliveryFrom: (action as any).deliveryFrom,
                isFDeliveryFromUpdate: true
            };
        }
        case SET_FLOWWOW_DELIVERY_TO: {
            return {
                ...state,
                flowwowDeliveryTo: (action as any).deliveryTo,
                isFDeliveryToUpdate: true
            };
        }
        case SET_FLOWWOW_DELIVERY_TYPE: {
            return {
                ...state,
                flowwowDeliveryType: (action as any).deliveryType,
                isFDeliveryTypeUpdate: true
            };
        }
        case SET_FLOWWOW_SENDER_NAME: {
            return {
                ...state,
                flowwowSenderName: (action as any).name,
                isFSenderNameUpdate: true
            };
        }
        case SET_FLOWWOW_SENDER_PHONE: {
            return {
                ...state,
                flowwowSenderPhone: (action as any).phone,
                isFSenderPhoneUpdate: true
            };
        }
        case SET_FLOWWOW_SENDER_CARD: {
            return {
                ...state,
                flowwowSenderCard: (action as any).card,
                isFSenderCardUpdate: true
            };
        }
        case SET_FLOWWOW_RECIPIENT_NAME: {
            return {
                ...state,
                flowwowRecipientName: (action as any).name,
                isFRecipientNameUpdate: true
            };
        }
        case SET_FLOWWOW_RECIPIENT_PHONE: {
            return {
                ...state,
                flowwowRecipientPhone: (action as any).phone,
                isFRecipientPhoneUpdate: true
            };
        }
        case SET_FLOWWOW_RECIPIENT_ADDRESS: {
            return {
                ...state,
                flowwowRecipientAddress: (action as any).address,
                isFRecipientAddressUpdate: true
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/CustomFlowers/customFlowers.ts